module.exports = __webpack_public_path__ + "static/media/error_sfx.1070dc87.mp3";